import { render, staticRenderFns } from "./TemplateMessageList.vue?vue&type=template&id=73e83f0e&scoped=true"
import script from "./TemplateMessageList.vue?vue&type=script&lang=js"
export * from "./TemplateMessageList.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageList.vue?vue&type=style&index=0&id=73e83f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e83f0e",
  null
  
)

export default component.exports